import * as ACTION_TYPES from './types';

const initialState = {
  status: {
    loadFee: -1,
  },
};

export default function reducer(state = initialState, action) {
  const { type, error, payload } = action;

  switch (type) {
    case ACTION_TYPES.BPDATA_GET_SETTINGS_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          loadFee: 0,
        },
        error: null,
      };

    case ACTION_TYPES.BPDATA_GET_SETTINGS_SUCCESS:
      return {
        ...state,
        status: {
          ...state.status,
          loadFee: 1,
        },
        fee: payload,
      };

    case ACTION_TYPES.BPDATA_GET_SETTINGS_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          loadFee: 2,
        },
        error,
      };

    case ACTION_TYPES.BPDATA_GET_MINIMUM_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          loadMinimumFee: 0,
        },
        error: null,
      };

    case ACTION_TYPES.BPDATA_GET_MINIMUM_SUCCESS:
      return {
        ...state,
        status: {
          ...state.status,
          loadMinimumFee: 1,
        },
        minimumFee: payload,
      };

    case ACTION_TYPES.BPDATA_GET_MINIMUM_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          loadMinimumFee: 2,
        },
        error,
      };
    case ACTION_TYPES.BPDATA_SAVE_SETTINGS_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          updating: 0,
        },
        error: null,
      };

    case ACTION_TYPES.BPDATA_SAVE_SETTINGS_SUCCESS:
      return {
        ...state,
        status: {
          ...state.status,
          updating: 1,
        },
      };

    case ACTION_TYPES.BPDATA_SAVE_SETTINGS_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          updating: 2,
        },
        error,
      };
    default:
      return state;
  }
}
